import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("om_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Terjadi kesalahan. Silakan coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

export const formatIDR = (value) => {
  if (value == null || isNaN(value)) return "Rp 0";
  return `Rp ${Math.round(value).toLocaleString("id-ID")}`;
};

export const buildWaLink = (phone, text) => {
  const clean = (phone || "").replace(/\D/g, "");
  // If starts with 0, replace with 62 (Indonesia)
  const normalized = clean.startsWith("0") ? "62" + clean.slice(1) : clean;
  return `https://wa.me/${normalized}?text=${encodeURIComponent(text || "")}`;
};

export default api;
